// This is copied from
// [@next-libs/storage](https://github.com/easyops-cn/next-libs/tree/master/libs/storage),
// and the types is refined.
// The usage of JsonStorage from @next-libs/storage should be deprecated,
// and migrated to from @next-core/brick-utils.
export class JsonStorage {
  constructor(storage) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "brick-next-";
    this.storage = storage;
    this.prefix = prefix;
  }
  setItem(name, value) {
    this.storage.setItem(this.prefix + name, JSON.stringify(value));
  }
  getItem(name) {
    var _this$storage$getItem;
    return JSON.parse((_this$storage$getItem = this.storage.getItem(this.prefix + name)) !== null && _this$storage$getItem !== void 0 ? _this$storage$getItem : "null");
  }
  removeItem(name) {
    return this.storage.removeItem(this.prefix + name);
  }
  clear() {
    return this.storage.clear();
  }
}
//# sourceMappingURL=JsonStorage.js.map